import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft, Volume2, VolumeX, Music, Headphones } from "lucide-react";
import { SFX, getAudioSettings, setMusicVolume, setSfxVolume, setMuted, playMusic } from "../utils/audio";

const Settings = () => {
  const navigate = useNavigate();
  const initial = getAudioSettings();
  const [musicVol, setMusicVolState] = useState(initial.musicVolume);
  const [sfxVol, setSfxVolState] = useState(initial.sfxVolume);
  const [muted, setMutedState] = useState(initial.muted);

  const handleMusic = (v) => {
    setMusicVolState(v);
    setMusicVolume(v);
  };
  const handleSfx = (v) => {
    setSfxVolState(v);
    setSfxVolume(v);
  };
  const handleMute = () => {
    SFX.click();
    const next = !muted;
    setMutedState(next);
    setMuted(next);
    if (!next) playMusic("menu");
  };
  const testSfx = () => SFX.crit();

  return (
    <div className="h-screen w-screen bg-slate-900 bg-dots flex flex-col overflow-hidden">
      <div className="flex items-center justify-between px-6 py-4 border-b-4 border-slate-950 bg-slate-800">
        <button
          data-testid="settings-back"
          onClick={() => { SFX.click(); navigate("/"); }}
          className="bg-slate-700 text-white border-4 border-slate-950 rounded-xl px-3 py-2 cartoon-shadow flex items-center gap-2"
        >
          <ArrowLeft className="w-4 h-4" /> Menu
        </button>
        <h1 className="font-display text-2xl sm:text-3xl font-bold">Paramètres</h1>
        <div className="w-24" />
      </div>

      <div className="flex-1 overflow-y-auto p-6 flex items-start justify-center">
        <div className="w-full max-w-xl space-y-6">

          {/* Mute */}
          <div className="bg-slate-800 border-4 border-slate-950 rounded-3xl p-5 cartoon-shadow-lg-static">
            <div className="flex items-center justify-between">
              <div>
                <h3 className="font-display text-lg font-bold flex items-center gap-2">
                  {muted ? <VolumeX className="w-5 h-5 text-rose-400" /> : <Volume2 className="w-5 h-5 text-emerald-400" />}
                  Son global
                </h3>
                <p className="text-xs text-slate-400 mt-1">{muted ? "Tous les sons sont coupés" : "Sons et musique actifs"}</p>
              </div>
              <button
                data-testid="settings-mute-toggle"
                onClick={handleMute}
                className={`${muted ? "bg-rose-500" : "bg-emerald-500"} text-white border-4 border-slate-950 rounded-xl px-4 py-2 font-display font-bold cartoon-shadow`}
              >
                {muted ? "Activer" : "Couper"}
              </button>
            </div>
          </div>

          {/* Music volume */}
          <div className="bg-slate-800 border-4 border-slate-950 rounded-3xl p-5 cartoon-shadow-lg-static">
            <h3 className="font-display text-lg font-bold flex items-center gap-2 mb-3">
              <Music className="w-5 h-5 text-sky-400" /> Volume Musique
            </h3>
            <div className="flex items-center gap-3">
              <input
                data-testid="settings-music-slider"
                type="range"
                min="0"
                max="100"
                value={Math.round(musicVol * 100)}
                onChange={(e) => handleMusic(parseInt(e.target.value, 10) / 100)}
                disabled={muted}
                className="flex-1 h-3 bg-slate-700 rounded-full appearance-none cursor-pointer disabled:opacity-40"
              />
              <span className="font-display font-bold text-lg w-12 text-right">{Math.round(musicVol * 100)}%</span>
            </div>
          </div>

          {/* SFX volume */}
          <div className="bg-slate-800 border-4 border-slate-950 rounded-3xl p-5 cartoon-shadow-lg-static">
            <h3 className="font-display text-lg font-bold flex items-center gap-2 mb-3">
              <Headphones className="w-5 h-5 text-yellow-400" /> Volume Effets
            </h3>
            <div className="flex items-center gap-3 mb-3">
              <input
                data-testid="settings-sfx-slider"
                type="range"
                min="0"
                max="100"
                value={Math.round(sfxVol * 100)}
                onChange={(e) => handleSfx(parseInt(e.target.value, 10) / 100)}
                disabled={muted}
                className="flex-1 h-3 bg-slate-700 rounded-full appearance-none cursor-pointer disabled:opacity-40"
              />
              <span className="font-display font-bold text-lg w-12 text-right">{Math.round(sfxVol * 100)}%</span>
            </div>
            <button
              data-testid="settings-test-sfx"
              onClick={testSfx}
              disabled={muted}
              className="w-full bg-yellow-400 text-slate-950 border-4 border-slate-950 rounded-xl py-2 font-display font-bold uppercase cartoon-shadow disabled:opacity-40"
            >
              Tester un effet
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Settings;
